const apiBaseURL = "https://mb.ask-me-2.com.au/api/v3";
const appKey =
  "smart-$2y$10$RdYWP.Z6T1DFDjSSunimzOUcMDGIBmyqCQ11/Vof.idVxCY14h8ky-api";
var apiActiveURL = apiBaseURL;
var appId = 7;
// const GOOGLE_MAP_KEY = "AIzaSyDdMQY2wOaHUnzHscBoqvNWmKDH4VUGUXQ";
const GOOGLE_MAP_KEY = "AIzaSyAPA2PaJ3zo1in4Nl0IJ8Mssc7cseSaD4Y";
export { apiActiveURL, appKey, appId, GOOGLE_MAP_KEY };
